import React, { Fragment } from 'react';
import { map, size } from 'lodash/fp';
import {
  CheckPicker,
  DatePicker,
  DateRangePicker,
  Radio,
  RadioGroup,
  SelectPicker
} from 'rsuite';
import GuestSelectPicker from '../../components/GuestSelectPicker';
import LocationCheckPicker from '../../components/LocationCheckPicker';
import LocationSelectPicker from '../../components/LocationSelectPicker';
import AssociatedDomainCheckPicker from '../../components/AssociatedDomainCheckPicker';
import AssociationLinkCheckPicker from '../../components/AssociationLinkCheckPicker';
import CFFileUpload from '../../components/CFFileUpload';
import DATE_RANGE_OPTIONS from '../../constants/DateRangeOptions';

export default {
  string: props => ({ ...props }),
  email: props => ({ type: 'email', ...props }),
  file: ({ onChange }) => ({
    accepter: CFFileUpload,
    onFileSelect: onChange
  }),
  text: props => ({ componentClass: 'textarea', rows: 4, ...props }),
  number: props => ({ type: 'number', ...props }),
  float: props => ({ type: 'number', steps: 2, ...props }),
  date: ({ style = {}, ...props }) => ({
    accepter: DatePicker,
    style: { width: 300, zIndex: 3, ...style },
    ...props
  }),
  select: ({ options, style = {}, ...props }) => ({
    accepter: SelectPicker,
    data: options,
    style: { width: 300, ...style },
    ...props
  }),
  radio: ({ options, ...props }) => ({
    accepter: RadioGroup,
    inline: size(options) <= 2,
    children: map(
      ({ value, label }) => (
        <Radio key={`opt-${value}`} value={`${value}`}>
          {label}
        </Radio>
      ),
      options
    ),
    ...props
  }),
  bool: props => ({
    accepter: RadioGroup,
    inline: true,
    children: (
      <Fragment>
        <Radio key="opt-no" value={0}>
          No
        </Radio>
        <Radio key="opt-yes" value={1}>
          Yes
        </Radio>
      </Fragment>
    ),
    ...props
  }),
  option_yesno: props => ({
    accepter: RadioGroup,
    inline: true,
    children: (
      <Fragment>
        <Radio key="opt-no" value="0">
          No
        </Radio>
        <Radio key="opt-yes" value="1">
          Yes
        </Radio>
      </Fragment>
    ),
    ...props
  }),
  checkbox: ({ options, style = {}, ...props }) => ({
    ...props,
    accepter: CheckPicker,
    data: options,
    style: { width: 300, ...style }
  }),
  guest_relation: ({ onChange, style, ...props }) => ({
    ...props,
    accepter: GuestSelectPicker,
    onSelect: onChange,
    style: { width: 300, ...style }
  }),
  location_select: ({ style, ...props }) => ({
    accepter: LocationSelectPicker,
    style: { width: 300, ...style },
    ...props
  }),
  location_multi_select: ({ style, ...props }) => ({
    ...props,
    accepter: LocationCheckPicker,
    style: { width: 300, ...style }
  }),
  associated_domain_multi_select: ({ style, ...props }) => ({
    ...props,
    accepter: AssociatedDomainCheckPicker,
    style: { width: 300, ...style }
  }),
  association_link_multi_select: ({ style, ...props }) => ({
    ...props,
    accepter: AssociationLinkCheckPicker,
    style: { width: 300, ...style }
  }),
  date_range: ({ style, ...props }) => ({
    ...props,
    accepter: DateRangePicker,
    ranges: DATE_RANGE_OPTIONS,
    style: { width: 300, ...style }
  })
};
